module.exports = __webpack_public_path__ + "img/Lampions_de_mariage.6ee198f.jpg";